import { ScrollBar } from 'components/CommonStyles'
import SearchInput from 'components/SearchInput'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp/FilterCheckBoxComp'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled from 'styled-components'
const Wrapper = styled.div`
  padding: 1rem 0.5rem;
`
const SpecialisationFilter = ({
  cityValue,
  setCityValue,
  cityList,
  keyCity,
  setKeyCity,
}) => {
  const [state, setState] = useState([])
  useEffect(() => {
    setState(cityList)
  }, [])
  const onChange = event => {
    let isChecked = event.target.checked
    let checkedName = state?.map(item => {
      return {
        ...item,
        checked: item.label === event.target.value ? isChecked : item.checked,
      }
    })

    let filterData = checkedName.filter(item => item.checked)
    let filteredName = filterData.map(item => item.label)
    setState(checkedName)
    setCityValue(filteredName)
  }

  return (
    <Wrapper column>
      <SearchInput
        width={'90%'}
        placeholder="Search by keyword"
        bordered={true}
        setSearchValue={setKeyCity}
        searchValue={keyCity}
      />

      <ScrollBar id="scrollableDiv" height={'28vh'}>
        <InfiniteScroll scrollableTarget="scrollableDiv" dataLength={'10'}>
          <FilterCheckBoxComp
            options={cityList}
            onChangeCheck={onChange}
            value={cityValue}
          />
        </InfiniteScroll>
      </ScrollBar>
    </Wrapper>
  )
}

export default SpecialisationFilter
